module.exports = __webpack_public_path__ + "static/media/loading-ring.289ee3ab.svg";